import { MetricsConfigColumnDefinition } from '@/types/MetricsConfigColumnDefinition';
import { PerformanceMetricMetadata } from '@/types/PerformanceMetricMetadata';

export const applySavedMetricsConfiguration = (
    columns: PerformanceMetricMetadata[],
    savedCategories: MetricsConfigColumnDefinition[]
): PerformanceMetricMetadata[] => {

    const flattenedSavedMetrics: PerformanceMetricMetadata[] = [];
    
    // Take the saved config and flatten it out to match the column definitions
    savedCategories?.forEach((category) => {
        category.children?.forEach((subcategory) => {
            // eslint-disable-next-line complexity
            subcategory.children?.forEach((column) => {
                // TODO: update PerformanceMetricMetadata so the field names match and we don't need to do this
                flattenedSavedMetrics.push({
                    id: column.field ?? '',
                    displayName: column.label ?? '',
                    dataType: column.dataType ?? '',
                    category: category.headerName ?? '',
                    subCategory: subcategory.headerName ?? '',
                    isEnabled: column.isSelected ?? false,
                    target: Number(column.trendTarget)
                });
            });
        });
    });

    return columns.map((definition) => {
        const { isEnabled, displayName } = flattenedSavedMetrics.find(
            (savedColumn) =>
                savedColumn.id === definition.id &&
                savedColumn.category === definition.category &&
                savedColumn.subCategory === definition.subcategory
        ) ?? {};
        
        return {
            ...definition, isEnabled, displayName: displayName ?? ''
        };
    });
};